import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { Icon, Intent } from '@blueprintjs/core';
import Clearfix from 'components/elements/clearfix';
import { IconNames } from '@blueprintjs/icons';
import { createForm } from 'rc-form';
// import * as _ from 'lodash';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import slug from 'constants/slug';
import IconRequired from 'components/elements/required-icon';
import FacilitySelect from 'components/elements/select-facility';
import { STYLE } from 'config';
import CustomDataSelect from 'components/elements/select-custom-data';
import { COLOR, DATE_FORMAT, DATA_FROM_YEAR } from 'config';
import {
  getDataForCustomSelect,
  FrequencyOfMonitoringData,
  QuaterOfChargeData,
  PaymentStatusData,
} from 'constants/custom-data';
import NumberInput from 'rc-input-number';
import { DateInput } from '@blueprintjs/datetime';
import moment from 'moment';
import { convertDateFromSever as convertDate } from 'utils/fnUtil';
import Message from 'rc-message';
// import dynamicRoleHOC from 'hoc/dynamicRole';

const ErrorContainer = styled.div`
  margin-top: 5px;
  color: #5c7080;
  font-size: 12px;
  color: red;
`;

const LabelContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-end;
`;

const HeaderContainer = styled.div`
  align-items: center;
  height: 38px;
  display: flex;
  justify-content: flex-start;
  cursor: pointer;
`;

// @dynamicRoleHOC()
class FacilityEnviProtectFeeForm extends React.Component {
  static propTypes = {
    isEdit: PropTypes.bool,
    initialValue: PropTypes.object,
    slugBack: PropTypes.string,
    handelSubmit: PropTypes.func,
    // facility: PropTypes.shape({
    //   _id: PropTypes.string,
    //   FacilityNameFull: PropTypes.string
    // })
  };

  constructor(props) {
    super(props);
    this.state = {
      rowCount: this.setInitialValue('ParametersList.length', 2),
    };
  }
  componentDidMount() {
    if (this.props.isEdit) {
      this.getSubmitTimeData();
      this.forceUpdate();
    }
  }

  CustomData_TanSuat6Thang = [
    { value: 'Lần 1', label: 'Lần 1' },
    { value: 'Lần 2', label: 'Lần 2' },
  ];

  setInitialValue(keyPath, defaultValue) {
    if (this.props.isEdit) {
      let value = _.result(this.props.initialValue, keyPath, defaultValue);
      if (!value) value = defaultValue;
      return value;
    }
    return defaultValue;
  }

  setSelInitialValue(keyPath, defaultValue, nameLabel) {
    if (this.props.isEdit) {
      let selItem = _.result(this.props.initialValue, keyPath);
      if (!selItem) return defaultValue;
      return {
        value: selItem._id,
        label: nameLabel ? selItem[nameLabel] : selItem.Name,
      };
    }
    return defaultValue;
  }

  submit = () => {
    this.props.form.validateFields((error, value) => {
      // console.log(value);
      value.facility = _.get(value.facility, 'value');
      value.FrequencyOfMonitoring = _.get(value.FrequencyOfMonitoring, 'value');
      value.QuaterOfCharge = _.get(value.QuaterOfCharge, 'value');
      value.PaymentStatus = _.get(value.PaymentStatus, 'value');
      value.SubmitTime = _.get(value.SubmitTime, 'value');

      if (error) return;
      this.props.handelSubmit(value);
    });
  };

  addRowCount = () => {
    this.setState({
      rowCount: this.state.rowCount + 1,
    });
  };

  deleteRow = async (rowIndex) => {
    const { form } = this.props;
    let ParametersList = form.getFieldValue('ParametersList');

    ParametersList = _.values(ParametersList);
    ParametersList = ParametersList.filter((item, index) => index !== rowIndex);
    ParametersList.map((item, index) => {
      return this.props.form.setFieldsValue({
        [`ParametersList.${index}`]: {
          Parameter: item.Parameter,
          Result: item.Result,
          Review: item.Review,
          Standard: item.Standard,
        },
      });
    });

    this.setState({
      rowCount: --this.state.rowCount,
    });
  };

  generateYear = () => {
    let loop = new Date().getFullYear() - DATA_FROM_YEAR;
    let arrYear = [];
    for (let i = loop; i >= 0; i--) {
      arrYear.push({
        value: DATA_FROM_YEAR + i,
        label: DATA_FROM_YEAR + i + '',
      });
    }
    return [...arrYear];
  };

  getSubmitTimeData() {
    const { getFieldValue } = this.props.form;
    let FrequencyOfMonitoring = _.result(
      getFieldValue('FrequencyOfMonitoring'),
      'value'
    );
    switch (FrequencyOfMonitoring) {
      case '3 tháng':
        return QuaterOfChargeData;
      case '6 tháng':
        return this.CustomData_TanSuat6Thang;
      case '1 năm':
        return this.generateYear();
      default:
        return [];
    }
  }

  render() {
    const { getFieldProps, getFieldError, setFieldsValue } = this.props.form;
    return (
      <div>
        <h4
          className='bp3-heading'
          style={{
            color: COLOR.SUCCESS,
          }}
        >
          Báo cáo quan trắc môi trường
        </h4>
        <Row>
          <Col xs={4}>
            <HeaderContainer>
              <Icon
                icon={IconNames.SAVED}
                iconSize={Icon.SIZE_LARGE}
                intent={Intent.PRIMARY}
                onClick={() => {
                  this.submit();
                }}
                style={{color: COLOR.SUCCESS}}
              />
              <Clearfix width={8} />
              <Link to={this.props.slugBack ? this.props.slugBack : slug.BASE}>
                <Icon
                  icon={IconNames.DISABLE}
                  iconSize={Icon.SIZE_LARGE}
                  intent={Intent.DANGER}
                />
              </Link>
            </HeaderContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tên cơ sở/dự án
              <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <FacilitySelect
              isDisabled={this.props.facility ? true : false}
              hideLabel
              fieldForm={{
                form: this.props.form,
                name: 'facility',
                option: {
                  initialValue: this.props.facility
                    ? {
                        value: this.props.facility._id,
                        label: this.props.facility.FacilityNameFull,
                      }
                    : null,
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Tên cơ sở/dự án',
                    },
                  ],
                  onChange: (val) => {
                    let FrequencyOfMonitoring = _.get(
                      val,
                      'obj.FrequencyOfMonitoring'
                    );
                    FrequencyOfMonitoring = FrequencyOfMonitoring
                      ? {
                          label: FrequencyOfMonitoring,
                          value: FrequencyOfMonitoring,
                        }
                      : undefined;
                    setFieldsValue({
                      FrequencyOfMonitoring,
                    });
                    if (!FrequencyOfMonitoring)
                      Message.warning({
                        content:
                          'Cơ Sở này chưa có thông tin Tần suất giám sát, vui lòng thêm trường này tại mục Cơ Sở',
                      });
                  },
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('facility') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tần suất giám sát <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              isDisabled
              hideLabel
              data={FrequencyOfMonitoringData}
              fieldForm={{
                form: this.props.form,
                name: 'FrequencyOfMonitoring',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('FrequencyOfMonitoring', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message:
                        'Vui lòng chọn Tần suất giám sát, vui lòng thêm trường này tại mục Cơ Sở',
                    },
                  ],
                  onChange: (val) => {
                    setFieldsValue({
                      SubmitTime: null,
                    });
                  },
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('FrequencyOfMonitoring') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>
        <Clearfix height={8} />
        {/* <Row>
          <Col xs={4}>
            <LabelContainer>Nguyên liệu sử dụng</LabelContainer>
          </Col>
          <Col xs={4}>
            <textarea
              className='bp3-input bp3-fill'
              dir='auto'
              {...getFieldProps('RawUsedMaterials', {
                initialValue: this.setInitialValue('RawUsedMaterials', '')
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Công suất sản phẩm</LabelContainer>
          </Col>
          <Col xs={4}>
            <textarea
              className='bp3-input bp3-fill'
              dir='auto'
              {...getFieldProps('ProductCapacity', {
                initialValue: this.setInitialValue('ProductCapacity', '')
              })}
            />
          </Col>
        </Row>
        <Clearfix height={8} /> */}
        <Row>
          <Col xs={4}>
            <LabelContainer>Năm nộp báo cáo</LabelContainer>
          </Col>
          <Col xs={4}>
            <NumberInput
              placeholder='Năm'
              {...getFieldProps('YearOfCharge', {
                initialValue: this.setInitialValue('YearOfCharge', ''),
              })}
            />
            <ErrorContainer>
              {(getFieldError('YearOfCharge') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Quý nộp báo cáo <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={QuaterOfChargeData}
              fieldForm={{
                form: this.props.form,
                name: 'QuaterOfCharge',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('QuaterOfCharge', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn Quý tính phí',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('QuaterOfCharge') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Tình trạng nộp <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={PaymentStatusData}
              fieldForm={{
                form: this.props.form,
                name: 'PaymentStatus',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('PaymentStatus', null)
                  ),
                  rules: [
                    {
                      required: true,
                      message: 'Vui lòng chọn tình trạng nộp phí',
                    },
                  ],
                },
              }}
            />
            <ErrorContainer>
              {(getFieldError('PaymentStatus') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Ngày nộp <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <DateInput
              popoverProps={{
                usePortal: true,
              }}
              formatDate={(date) => moment(date).format(DATE_FORMAT)}
              parseDate={(str) => moment(str).toDate()}
              placeholder='Ngày nộp'
              {...getFieldProps('SubmitDate', {
                initialValue: convertDate(
                  this.setInitialValue('SubmitDate', null)
                ),
                rules: [
                  {
                    required: true,
                    message: 'Vui lòng nhập ngày nộp',
                  },
                ],
              })}
            />
            <ErrorContainer>
              {(getFieldError('SubmitDate') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row>

        {/* <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer style={STYLE.REQUIREDFIELD}>
              Thời gian nộp <IconRequired />
            </LabelContainer>
          </Col>
          <Col xs={4}>
            <CustomDataSelect
              hideLabel
              data={this.getSubmitTimeData()}
              fieldForm={{
                form: this.props.form,
                name: 'SubmitTime',
                option: {
                  initialValue: getDataForCustomSelect(
                    this.setInitialValue('SubmitTime', null)
                  ),
                  rules: [
                    {
                      validator: (rule, val, callback) => {
                        if (!_.result(val, 'value'))
                          callback(new Error('Thời gian nộp is required'));
                        callback();
                      }
                    }
                  ]
                }
              }}
            />
            <ErrorContainer>
              {(getFieldError('SubmitTime') || []).join(', ')}
            </ErrorContainer>
          </Col>
        </Row> */}

        {/* <Clearfix height={8} />
        <Row>
          <Col xs={4}>
            <LabelContainer>Danh sách các thông số quan trắc</LabelContainer>
            <LabelContainer>
              <Button icon="add" onClick={this.addRowCount}>
                Add
              </Button>
            </LabelContainer>
          </Col>
          <Col xs={6}>
            <Table
              numRows={this.state.rowCount}
              defaultRowHeight={40}
              defaultColumnWidth={150}
              enableGhostCells={true}
              selectionModes={SelectionModes.NONE}
              enableRowResizing={false}
            >
              <Column
                name="Thông số"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <CellContainer>
                        <InputGroup
                          {...getFieldProps(
                            `ParametersList.${rowIndex}.Parameter`,
                            {
                              initialValue: this.setInitialValue(
                                `ParametersList.${rowIndex}.Parameter`,
                                ''
                              )
                            }
                          )}
                        />
                      </CellContainer>
                    </Cell>
                  );
                }}
              />
              <Column
                name="Kết quả"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <CellContainer>
                        <InputGroup
                          {...getFieldProps(
                            `ParametersList.${rowIndex}.Result`,
                            {
                              initialValue: this.setInitialValue(
                                `ParametersList.${rowIndex}.Result`,
                                ''
                              )
                            }
                          )}
                        />
                      </CellContainer>
                    </Cell>
                  );
                }}
              />
              <Column
                name="Quy chuẩn"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <CellContainer>
                        <InputGroup
                          {...getFieldProps(
                            `ParametersList.${rowIndex}.Standard`,
                            {
                              initialValue: this.setInitialValue(
                                `ParametersList.${rowIndex}.Standard`,
                                ''
                              )
                            }
                          )}
                        />
                      </CellContainer>
                    </Cell>
                  );
                }}
              />
              <Column
                name="Đánh giá"
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <CellContainer>
                        <InputGroup
                          {...getFieldProps(
                            `ParametersList.${rowIndex}.Review`,
                            {
                              initialValue: this.setInitialValue(
                                `ParametersList.${rowIndex}.Review`,
                                ''
                              )
                            }
                          )}
                        />
                      </CellContainer>
                    </Cell>
                  );
                }}
              />
              <Column
                name=""
                cellRenderer={rowIndex => {
                  return (
                    <Cell>
                      <CellContainer>
                        <Button
                          icon="delete"
                          onClick={() => {
                            this.deleteRow(rowIndex);
                          }}
                        />
                      </CellContainer>
                    </Cell>
                  );
                }}
              />
            </Table>
          </Col>
        </Row> */}

        <Clearfix height={8} />
      </div>
    );
  }
}

export default createForm()(FacilityEnviProtectFeeForm);



// WEBPACK FOOTER //
// ./src/containers/FacilityEnviMonitoringReportContainer/FacilityEnviMonitoringReportForm/index.js